import {
  EMAILREGEX,
  PHONEREGEX,
  CITYREGEX,
  PASSREGEX,
  STREETREGEX,
  ZIPREGEX,
  NAMEREGEX,
  NUMSREGEX,
} from "../../../constants/regex";
import { capitalizeFirstLetter } from "../../../utils/display";
import { checkLuhn } from "../../../utils/checkLuhn";
import { getCardType } from "../../../utils/validators/card";

export const validateField = (fieldName, regex) => (value) => {
  if (!value) {
    return `${capitalizeFirstLetter(fieldName)} is required`;
  }
  if (!regex.test(value.trim())) {
    return `Invalid ${fieldName}`;
  }
  return;
};
export const firstName = validateField("first name", NAMEREGEX);
export const lastName = validateField("last name", NAMEREGEX);
export const street = validateField("street", STREETREGEX);
export const city = validateField("city", CITYREGEX);
export const zip = validateField("zip code", ZIPREGEX);
export const email = validateField("email", EMAILREGEX);
export const validatePassword = validateField("password", PASSREGEX);
export const verificationCode = validateField("verification code", NUMSREGEX);
export const confirmPassword = (confirmPassword, { password }) => {
  if (!password || !confirmPassword) {
    return "Passwords must match";
  }
  if (password !== confirmPassword) {
    return "Passwords must match";
  }
  return;
};
export const creditCard = (value) => {
  if (!value) {
    return "Credit card is required";
  }
  if (!checkLuhn(value.trim())) {
    return "Invalid credit card";
  }
};
export const ccv = (value) => {
  if (!value) {
    return "CCV is required";
  }
  if (value.length < 3) {
    return "Invalid CCV";
  }
};
export const month = (value) => {
  if (!value) {
    return "Month is required";
  }
};
export const year = (value) => {
  if (!value) {
    return "Year is required";
  }
};
export const state = (value) => {
  if (!value) {
    return "State is required";
  }
};
export const acceptTerms = (value) => {
  if (!value) {
    return "You must accept the terms & conditions";
  }
};
export const accountType = (value) => {
  if (!value) {
    return "Account type is required";
  }
};
export const creditCardType = (value) => {
  const creditCardType = getCardType(value);
  if (!creditCardType.length) {
    return "Please enter a valid credit card";
  }
  return;
};
export const phone = (value) => {
  if (!value) {
    return "Phone is required";
  }
  if (!PHONEREGEX.test(value.trim())) {
    return "Invalid phone";
  }
  if (value.length < 10) {
    return "Invalid phone";
  }
  return;
};
export const getPasswordFieldsPassed = (password = "") => {
  let fieldsPassed = {
    lowerCasePass: false,
    upperCasePass: false,
    lengthPass: false,
    numberPass: false,
    specialCharacterPass: false,
  };
  if (/[a-z]/.test(password)) {
    fieldsPassed = { ...fieldsPassed, lowerCasePass: true };
  }
  if (/[A-Z]/.test(password)) {
    fieldsPassed = { ...fieldsPassed, upperCasePass: true };
  }
  if (/[0-9]/.test(password)) {
    fieldsPassed = { ...fieldsPassed, numberPass: true };
  }
  if (/[$@$!%*?&]/.test(password)) {
    fieldsPassed = { ...fieldsPassed, specialCharacterPass: true };
  }
  if (password.length >= 8) {
    fieldsPassed = { ...fieldsPassed, lengthPass: true };
  }
  return fieldsPassed;
};
export const address = (value) => {
  if (!value) {
    return "Address is required";
  }
};
